import {connect} from 'react-redux';

import {UsersState, setUsersAction} from '@pluto/users';
import UsersListContainer from './UsersListContainer';

export type UsersListState = {users: UsersState};

export const mapState = (state: UsersListState): UsersListState => {
    const {users} = state;
    
    return {
        users,
    };
};

export const mapDispatch = {
    setUsers: setUsersAction,
};

export default connect(mapState, mapDispatch)(UsersListContainer);
